import React from "react";
import "./Welcome.css";
import SearchIcon from "@material-ui/icons/Search";
import FlightTakeoffIcon from "@material-ui/icons/FlightTakeoff";
import Image1 from "../../images/tashkent1.jpg";
import Image2 from "../../images/tashkent2.jpg";
import Image3 from "../../images/tashkent3.jpg";
import { Link } from "react-router-dom";
import Button from '../../components/Button'


function index() {
  return (
    <div className="welcome">
      <div className="welcome_nav">
        <div className="welcome_nav_logo">
          <p>
            Travel <FlightTakeoffIcon />
          </p>
          <span>Uzbekistan</span>
        </div>
        
      </div>
      <div className="welcome_center_text">
        <p>Welcome to</p>
        <h1>Uzbekistan</h1>
        <Link to="/homepage">
          <Button title="explore" />
        </Link>
      </div>
      <div className="welcome_footer">
        <div className="welcome_footer_text">
          <p>
            tashkent: the heart <br /> of uzbekistan
          </p>
        </div>
        <div className="welcome_footer_images">
          <img src={Image1} alt="iaa" />
          <img src={Image2} alt="iaa" />
          <img src={Image3} alt="iaa" />
        </div>
      </div>
    </div>
  );
}

export default index;
